/**
 * Die naechste freie Kennung fuer ein neues Packstueck (ADR 0013 §7).
 *
 * Wer eine Kiste anlegt, soll nicht nachschlagen muessen, welche Nummer als
 * naechste dran ist. Nach GB-08 kommt GB-09, nach WK-3 kommt WK-4 -- in der
 * Schreibweise, die der Ortsverband schon benutzt.
 *
 * Rein: Das Geraet schlaegt aus seiner lokalen Kopie vor, der Server prueft
 * beim Anlegen, dass die Kennung wirklich frei ist.
 */
/** „GB-08“ → Vorsilbe „GB-“ und Nummer „08“. Ohne Nummer am Ende keine Reihe. */
function zerlegen(kennung) {
    const treffer = /^(.*?)(\d+)$/.exec(kennung);
    if (treffer === null)
        return null;
    const [, vorsilbe = "", nummer = ""] = treffer;
    return { vorsilbe, nummer };
}
/** Hoechstens so viele Reihen stehen zur Wahl -- mehr liest keiner. */
export const HOECHSTENS_VORSCHLAEGE = 4;
/**
 * Je Reihe die naechste freie Kennung, die juengste Reihe zuerst.
 *
 * `belegt` sind alle Kennungen und Nummern, die es schon gibt: Kennungen der
 * Lagerorte und Nummern der Artikel -- die Kennung wird ja zur Nummer, wenn
 * das Packstueck keine THW-Nummer hat. Die Nummer waechst ueber die hoechste
 * der Reihe hinaus; Luecken werden nicht aufgefuellt, damit eine ausgemusterte
 * Kiste nicht mit einer neuen verwechselt wird.
 */
export function kennungVorschlaege(packstuecke, belegt) {
    const reihen = new Map();
    const juengste = [...packstuecke].sort((a, b) => Date.parse(b.angelegt_am) - Date.parse(a.angelegt_am));
    for (const p of juengste) {
        const teile = zerlegen(p.kennung);
        if (teile === null)
            continue;
        const zahl = Number(teile.nummer);
        const reihe = reihen.get(teile.vorsilbe);
        if (reihe === undefined) {
            reihen.set(teile.vorsilbe, { hoechste: zahl, breite: teile.nummer.length, vorbild: p });
        }
        else if (zahl > reihe.hoechste) {
            reihe.hoechste = zahl;
            reihe.breite = Math.max(reihe.breite, teile.nummer.length);
        }
    }
    const vorschlaege = [];
    for (const [vorsilbe, reihe] of reihen) {
        let zahl = reihe.hoechste + 1;
        let kennung = `${vorsilbe}${String(zahl).padStart(reihe.breite, "0")}`;
        while (belegt.has(kennung) && zahl < reihe.hoechste + 1000) {
            zahl += 1;
            kennung = `${vorsilbe}${String(zahl).padStart(reihe.breite, "0")}`;
        }
        // Kennungen sind hoechstens 16 Zeichen lang (Vertrag).
        if (kennung.length > 16 || belegt.has(kennung))
            continue;
        const alt = reihe.vorbild.kennung;
        const bezeichnung = reihe.vorbild.bezeichnung.includes(alt)
            ? reihe.vorbild.bezeichnung.replace(alt, kennung)
            : reihe.vorbild.bezeichnung;
        vorschlaege.push({ kennung, bezeichnung });
        if (vorschlaege.length === HOECHSTENS_VORSCHLAEGE)
            break;
    }
    return vorschlaege;
}
/**
 * Die naechste freie Kennung fuer einen Packstuecktyp (ADR 0028): nach GB-08
 * kommt GB-09. Zwei Stellen sind ueblich, eine Grenze gibt es nicht -- nach
 * GB-99 kommt GB-100. Luecken werden nicht aufgefuellt, damit eine
 * ausgemusterte Kiste nicht mit einer neuen verwechselt wird.
 *
 * `belegt` sind alle Kennungen der Lagerorte und alle Nummern der Artikel.
 */
export function naechsteKennung(kuerzel, belegt) {
    const alle = new Set(belegt);
    const vorsilbe = `${kuerzel}-`;
    let hoechste = 0;
    for (const k of alle) {
        if (!k.startsWith(vorsilbe))
            continue;
        const rest = k.slice(vorsilbe.length);
        if (/^\d+$/.test(rest))
            hoechste = Math.max(hoechste, Number(rest));
    }
    let zahl = hoechste + 1;
    let kennung = `${vorsilbe}${String(zahl).padStart(2, "0")}`;
    while (alle.has(kennung)) {
        zahl += 1;
        kennung = `${vorsilbe}${String(zahl).padStart(2, "0")}`;
    }
    return kennung;
}
//# sourceMappingURL=kennung.js.map